import React, { Component } from "react";
import img from "../../img/audience1st.png";
import "../../styles/framework.min.scss";
import styles from "../../styles/home.module.scss";

class Audience1st extends Component {
  render() {
    const { hideModal } = this.props;
    return (
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.heading}>Audience1st</span>
          <div className={styles.dismiss}>
            <button className={styles.btn} onClick={hideModal}>
              <i>
                <svg viewBox="0 0 352 512">
                  <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" />
                </svg>
              </i>
            </button>
          </div>
        </div>
        <div className={styles.body}>
          <img className={styles.image} src={img} />
          <p className={styles.blurb}>
            I helped build a movie ticketing service for my CS169 Software
            Engineering course professor's side project using Ruby on Rails.
          </p>
        </div>
      </div>
    );
  }
}

export default Audience1st;
